import { create } from "zustand";
import { Patient } from "../types";

export interface SelectedPatient {
  id: string;
  initialData?: Patient;
}

interface PatientStore {
  selectedPatient: SelectedPatient | null;
  setSelectedPatient: (patient: SelectedPatient | null) => void;
}

export const usePatientStore = create<PatientStore>((set) => ({
  selectedPatient: null,
  setSelectedPatient: (patient) => set({ selectedPatient: patient }),
}));
